import document from './en/document.json';
import enumeration from './en/enum.json';
import models from './en/models.json';

export default {
  ...document,
  ...enumeration,
  ...models
};
